import Button from "@/Components/Button";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import { stringToSlug } from "@/helpers/string";
import { useForm } from "@inertiajs/inertia-react";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Create from "./Create";

const Roles = ({ roles }) => {
    return (
        <div className="max-w-2xl bg-white p-4 rounded-xl">
            <h4 className="text-2xl font-bold mb-8">Roles</h4>
            <Create className="mb-4" />

            <div className="flex flex-col items-center gap-2">
                {roles?.map(role => (
                    <Role key={`role-${role.id}`} {...role} />
                ))}
            </div>
        </div>
    );
};

const Role = ({ id, name, label }) => {
    const [placeholderName, setPlaceholderName] = useState(stringToSlug(label));
    const [isEditing, setIsEditing] = useState(false);

    const { data, setData, put, delete: destroy } = useForm({
        name,
        label
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        put(route('roles.update', id));
    }

    const handleDelete = () => {
        Swal.fire({
            icon: 'warning',
            title: 'Estás seguro de que quieres borrar este rol?',
            confirmButtonColor: '#ff0000',
            confirmButtonText: 'Eliminar Rol',
            showCancelButton:true,
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                destroy(route('roles.delete', id))
            }
        })
    }

    useEffect(() => {
        const slug = stringToSlug(data.label, '_');
        setPlaceholderName(slug)
    }, [data.label]);

    useEffect(() => {
        const slug = stringToSlug(data.name, '_');
        setData('name', slug);
    }, [data.name])

    return (
        <form onSubmit={submit} className="flex justify-between items-center w-full py-2 px-6 shadow border-gray-600 rounded-2xl">
            <div>

                {isEditing ? (
                    <div className="grid grid-cols-2 gap-2">
                        <div>
                            {/* <Label forInput="label" value="Nombre" /> */}
                            <Input placeholder="Nombre" name="label" handleChange={onHandleChange} value={data.label} className="w-full" />
                        </div>
                        <div>
                            {/* <Label forInput="name" value="Identificador" /> */}
                            <Input
                                onDoubleClick={() => {
                                    if (!data.name) {
                                        setData('name', placeholderName)
                                    }
                                }}
                                placeholder={placeholderName || 'Identificador'}
                                name="name"
                                handleChange={onHandleChange}
                                value={data.name} className="w-full"
                            />
                        </div>
                    </div>
                ) : (
                    <h4>{label}</h4>
                )}
            </div>

            {isEditing ? (
                <div className="flex items-center gap-2 pl-2">
                    <Button type="button" style={{ backgroundColor: 'gray'}} onClick={() => setIsEditing(false)}>Cancelar</Button>
                    <Button type="submit">Guardar</Button>
                </div>
            ) : (
                <div className="flex items-center gap-2 pl-2">
                    <Button type="button" onClick={() => setIsEditing(true)}>Editar</Button>
                    <Button type="button" onClick={handleDelete} className="bg-red-500">Eliminar</Button>
                </div>
            )}
        </form>
    )
}


export default Roles;
